import classes from './input.module.css';

const TextBox = ({
  customClass,
  isTouched,
  isValid,
  errorMessage,
  attributes,
  value,
  valueChangeHandler,
  inputBlurHandler,
  onKeyDown,
  type = "text",
  maxLength = null,

}) => {

  // Set default class and add customClass conditionally
  const styles = ['w-full']; // default class

  if (customClass) {
    styles.push(customClass); // add customClass if provided
  }

  if (isTouched && isValid && errorMessage) {
    styles.push(classes.invalid); // add invalid class conditionally
  }

  const error = errorMessage ? <div className={`errorTxt`} >{errorMessage}</div> : null

  return (
    <>
      <input
        className={styles.join(' ')}
        {...attributes}
        value={value}
        onChange={valueChangeHandler}
        onBlur={inputBlurHandler}
        onKeyDown={onKeyDown}
        type={type}
        maxLength={maxLength}

      />
      {error}
    </>
  )
}

export default TextBox